// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InAppAgentWidget.css - Modern In-App Financial Assistant Styles */

.am-agent-fab {
    position: fixed;
    bottom: 28px;
    right: 28px;
    z-index: 1200;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
    color: #ffffff;
    border: none;
    box-shadow: 0 8px 24px rgba(30, 64, 175, 0.45);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.am-agent-fab:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 12px 28px rgba(30, 64, 175, 0.55);
}

.am-agent-fab:active {
    transform: scale(0.95);
}

.am-agent-fab .pi {
    font-size: 1.5rem;
}

/* Online Pulse Indicator */
.am-agent-status-pulse {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 14px;
    height: 14px;
    background-color: #10b981;
    border: 2px solid #ffffff;
    border-radius: 50%;
    animation: agent-pulse 2s infinite;
}

@keyframes agent-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
    }
    70% {
        box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
    }
}

/* Sidebar Custom Styling */
.am-agent-sidebar .p-sidebar-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 !important;
    overflow: hidden;
    background-color: #f8fafc;
}

.am-agent-header {
    padding: 16px 20px;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.am-agent-title-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.am-agent-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #2563eb, #38bdf8);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 1.3rem;
}

.am-agent-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #f8fafc;
    margin: 0;
}

.am-agent-subtitle {
    font-size: 0.75rem;
    color: #94a3b8;
    margin: 2px 0 0 0;
    display: flex;
    align-items: center;
    gap: 6px;
}

.am-status-dot-inline {
    width: 7px;
    height: 7px;
    background-color: #10b981;
    border-radius: 50%;
    display: inline-block;
}

/* Quick Prompt Chips */
.am-agent-chips-bar {
    padding: 10px 16px;
    background-color: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    gap: 8px;
    overflow-x: auto;
    white-space: nowrap;
}

.am-agent-chip {
    font-size: 0.75rem !important;
    cursor: pointer;
    background-color: #eff6ff !important;
    color: #1d4ed8 !important;
    border: 1px solid #bfdbfe !important;
    border-radius: 16px !important;
    padding: 4px 10px !important;
    transition: all 0.15s ease;
}

.am-agent-chip:hover {
    background-color: #dbeafe !important;
    transform: translateY(-1px);
}

/* Messages Scroll Container */
.am-agent-messages {
    flex: 1 1;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.am-msg-row {
    display: flex;
    flex-direction: column;
    max-width: 85%;
}

.am-msg-user {
    align-self: flex-end;
}

.am-msg-agent {
    align-self: flex-start;
}

.am-bubble {
    padding: 12px 16px;
    border-radius: 16px;
    font-size: 0.88rem;
    line-height: 1.45;
    word-break: break-word;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.am-msg-user .am-bubble {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    border-bottom-right-radius: 4px;
}

.am-msg-agent .am-bubble {
    background-color: #ffffff;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-bottom-left-radius: 4px;
}

.am-msg-time {
    font-size: 0.68rem;
    color: #94a3b8;
    margin-top: 4px;
    padding: 0 4px;
}

.am-msg-user .am-msg-time {
    text-align: right;
}

/* Tool execution pill */
.am-tool-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background-color: #f1f5f9;
    color: #475569;
    font-size: 0.72rem;
    padding: 2px 8px;
    border-radius: 6px;
    margin-bottom: 6px;
    border: 1px solid #cbd5e1;
    font-family: monospace;
}

/* Tables inside chat bubbles */
.am-chat-table {
    width: 100%;
    border-collapse: collapse;
    margin: 8px 0;
    font-size: 0.8rem;
}

.am-chat-table th {
    background-color: #f1f5f9;
    padding: 6px 8px;
    text-align: left;
    border: 1px solid #e2e8f0;
}

.am-chat-table td {
    padding: 5px 8px;
    border: 1px solid #e2e8f0;
}

/* Typing Indicator */
.am-typing-indicator {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
}

.am-typing-dot {
    width: 6px;
    height: 6px;
    background-color: #94a3b8;
    border-radius: 50%;
    animation: typing-bounce 1.4s infinite ease-in-out both;
}

.am-typing-dot:nth-child(1) { animation-delay: -0.32s; }
.am-typing-dot:nth-child(2) { animation-delay: -0.16s; }

@keyframes typing-bounce {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
}

/* Input Area */
.am-agent-input-bar {
    padding: 12px 16px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.am-agent-input-bar input {
    flex: 1 1;
    border-radius: 20px !important;
    padding: 10px 16px !important;
    font-size: 0.88rem !important;
}

.am-agent-send-btn {
    border-radius: 50% !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/InAppAgentWidget.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,cAAc;IACd,YAAY;IACZ,8CAA8C;IAC9C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mDAAmD;AACvD;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;IACpC,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA,8BAA8B;AAC9B;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA,8BAA8B,uBAAuB,EAAE;AACvD,8BAA8B,uBAAuB,EAAE;;AAEvD;IACI,gBAAgB,mBAAmB,EAAE;IACrC,MAAM,mBAAmB,EAAE;AAC/B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":["/* InAppAgentWidget.css - Modern In-App Financial Assistant Styles */\n\n.am-agent-fab {\n    position: fixed;\n    bottom: 28px;\n    right: 28px;\n    z-index: 1200;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);\n    color: #ffffff;\n    border: none;\n    box-shadow: 0 8px 24px rgba(30, 64, 175, 0.45);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.am-agent-fab:hover {\n    transform: translateY(-3px) scale(1.05);\n    box-shadow: 0 12px 28px rgba(30, 64, 175, 0.55);\n}\n\n.am-agent-fab:active {\n    transform: scale(0.95);\n}\n\n.am-agent-fab .pi {\n    font-size: 1.5rem;\n}\n\n/* Online Pulse Indicator */\n.am-agent-status-pulse {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    width: 14px;\n    height: 14px;\n    background-color: #10b981;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n    animation: agent-pulse 2s infinite;\n}\n\n@keyframes agent-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n    }\n    70% {\n        box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n    }\n}\n\n/* Sidebar Custom Styling */\n.am-agent-sidebar .p-sidebar-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n    background-color: #f8fafc;\n}\n\n.am-agent-header {\n    padding: 16px 20px;\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.am-agent-title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.am-agent-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: linear-gradient(135deg, #2563eb, #38bdf8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    font-size: 1.3rem;\n}\n\n.am-agent-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #f8fafc;\n    margin: 0;\n}\n\n.am-agent-subtitle {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    margin: 2px 0 0 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.am-status-dot-inline {\n    width: 7px;\n    height: 7px;\n    background-color: #10b981;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n/* Quick Prompt Chips */\n.am-agent-chips-bar {\n    padding: 10px 16px;\n    background-color: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    gap: 8px;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n\n.am-agent-chip {\n    font-size: 0.75rem !important;\n    cursor: pointer;\n    background-color: #eff6ff !important;\n    color: #1d4ed8 !important;\n    border: 1px solid #bfdbfe !important;\n    border-radius: 16px !important;\n    padding: 4px 10px !important;\n    transition: all 0.15s ease;\n}\n\n.am-agent-chip:hover {\n    background-color: #dbeafe !important;\n    transform: translateY(-1px);\n}\n\n/* Messages Scroll Container */\n.am-agent-messages {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.am-msg-row {\n    display: flex;\n    flex-direction: column;\n    max-width: 85%;\n}\n\n.am-msg-user {\n    align-self: flex-end;\n}\n\n.am-msg-agent {\n    align-self: flex-start;\n}\n\n.am-bubble {\n    padding: 12px 16px;\n    border-radius: 16px;\n    font-size: 0.88rem;\n    line-height: 1.45;\n    word-break: break-word;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n}\n\n.am-msg-user .am-bubble {\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    border-bottom-right-radius: 4px;\n}\n\n.am-msg-agent .am-bubble {\n    background-color: #ffffff;\n    color: #1e293b;\n    border: 1px solid #e2e8f0;\n    border-bottom-left-radius: 4px;\n}\n\n.am-msg-time {\n    font-size: 0.68rem;\n    color: #94a3b8;\n    margin-top: 4px;\n    padding: 0 4px;\n}\n\n.am-msg-user .am-msg-time {\n    text-align: right;\n}\n\n/* Tool execution pill */\n.am-tool-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    background-color: #f1f5f9;\n    color: #475569;\n    font-size: 0.72rem;\n    padding: 2px 8px;\n    border-radius: 6px;\n    margin-bottom: 6px;\n    border: 1px solid #cbd5e1;\n    font-family: monospace;\n}\n\n/* Tables inside chat bubbles */\n.am-chat-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 8px 0;\n    font-size: 0.8rem;\n}\n\n.am-chat-table th {\n    background-color: #f1f5f9;\n    padding: 6px 8px;\n    text-align: left;\n    border: 1px solid #e2e8f0;\n}\n\n.am-chat-table td {\n    padding: 5px 8px;\n    border: 1px solid #e2e8f0;\n}\n\n/* Typing Indicator */\n.am-typing-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 8px 12px;\n}\n\n.am-typing-dot {\n    width: 6px;\n    height: 6px;\n    background-color: #94a3b8;\n    border-radius: 50%;\n    animation: typing-bounce 1.4s infinite ease-in-out both;\n}\n\n.am-typing-dot:nth-child(1) { animation-delay: -0.32s; }\n.am-typing-dot:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes typing-bounce {\n    0%, 80%, 100% { transform: scale(0); }\n    40% { transform: scale(1); }\n}\n\n/* Input Area */\n.am-agent-input-bar {\n    padding: 12px 16px;\n    background-color: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.am-agent-input-bar input {\n    flex: 1;\n    border-radius: 20px !important;\n    padding: 10px 16px !important;\n    font-size: 0.88rem !important;\n}\n\n.am-agent-send-btn {\n    border-radius: 50% !important;\n    width: 40px !important;\n    height: 40px !important;\n    padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
